import {useDispatch, useSelector} from "react-redux";
import {appConfigSelector, rxSubmitSettingsAccounts} from "../../../slices/appSlice";
import {useState} from "react";
import useToast from "../../../util/useToast";
import {useTranslation} from "react-i18next";
import {updateSettingsAccounts} from "../../../api/ApiSettings";
import {selectAllAccounts} from "../../../slices/accountsSlice";
import useNetwork from "../../../util/useNetwork";

const useSettingsAccounts = () => {
  const dispatch = useDispatch();

  const {showToastSuccess} = useToast();
  const {handleNetworkError} = useNetwork();
  const {t} = useTranslation("settings_accounts");

  const accounts = useSelector(selectAllAccounts);
  const {defaultTransactionsPeriod, defaultTransactionsAccount} = useSelector(appConfigSelector);

  const [editedSettings, setEditedSettings] = useState({
    errors: {},
    defaultTransactionsPeriod,
    defaultTransactionsAccount
  });

  const availableAccounts = [{id: null, name: t("settings_accounts_editor_choose_account")}]

  accounts.filter(a => a.active || a.id === defaultTransactionsAccount).forEach(a => availableAccounts.push(a));

  const submit = e => {
    e.preventDefault();

    dispatch(rxSubmitSettingsAccounts(editedSettings));

    updateSettingsAccounts(editedSettings).catch(handleNetworkError);

    showToastSuccess(t("toast_accounts_editor_saved"));
  };

  const updateSetting = field => event => {
    const values = {};

    switch (field) {
      case "defaultTransactionsAccount":
      case "defaultTransactionsPeriod":
        values[field] = event;
        break;
      default:
        values[field] = event.target.value;
        break;
    }

    setEditedSettings(prev => ({...prev, ...values}));
  };

  return {
    t,
    editedSettings,
    submit,
    updateSetting,
    availableAccounts
  };
};

export default useSettingsAccounts;
